"use client";
import { useOnboardContext } from "@/app/(onboard)/OnboardContext";
import { useEffect } from "react";
import SelectLabel from "@/component/ui/SelectLabel";
import Button from "@/component/ui/Button";
import Text from "@/component/ui/Text";
import Link from "next/link";
import { addCountry } from "@/store/slices/onboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store";
import { useRouter } from "next/navigation";
import { useGetCountriesQuery, Country } from "@/store/api/countryApi";

const CountryPage = () => {
    const { setProcessStep } = useOnboardContext();
    const dispatch = useDispatch<AppDispatch>();
    const { country: savedCountryId } = useSelector((state: RootState) => state.onboard);
    const router = useRouter();

    const { data: countries = [], isLoading, isError } = useGetCountriesQuery();

    const selected = countries.find((c: Country) => c.id === savedCountryId) ?? null;

    const error = isError ? "Could not load countries. Please try again." : null;

    useEffect(() => {
        setProcessStep(1);
        document.title = "Select Country";
    }, [setProcessStep]);

    const onContinue = () => {
        if (isLoading) return;
        if (!selected) {
            // User-triggered validation still needs local state — see note below
            return;
        }
        dispatch(addCountry(selected.id));
        router.replace("/package");
    };

    return (
        <div className="flex flex-col gap-4">
            {error && (
                <div className="p-3 border bg-inactivestatus border-inactivelabel rounded-lg">
                  <Text fontType="paragraph" className="text-inactivelabel">{error}</Text>
                </div>
            )}
            

            {countries.map((country: Country) => (
                <SelectLabel
                    key={`country-${country.id}`}
                    item={{
                        id: country.id,
                        title: country.title,
                        summary: country.description,
                        flag: true,
                        flagHref: country.flag,
                    }}
                    active={selected?.id === country.id}
                    onClick={() => dispatch(addCountry(country.id))}
                />
            ))}

            <Button className="flex justify-center mt-2" btnType="button" text="Continue" color={isLoading ? "disabled" : "primary"} onClick={onContinue}/>

            <div className="text-center">
                <Text fontType="paragraph">Already have an account?{" "}<Link href="/login" className="text-brand">Login</Link></Text>
            </div>
        </div>
    );
};

export default CountryPage;